/**
 * Katha Mithra emblem. Single source of truth for the brand mark so the
 * image swap (or future SVG inline) happens in one place.
 *
 * Drop the asset at frontend/public/logo.png — referenced as /logo.png so
 * it resolves under any deployed base path.
 */
export default function BrandLogo({ className = '', alt = '' }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      aria-hidden={alt ? undefined : true}
      className={`object-contain ${className}`.trim()}
      draggable={false}
    />
  );
}
